import {styled} from '@linaria/react';
import {Link} from '@aboutyou/router';

export const UnstyledLinkLinaria = styled(Link)`
  &,
  &:hover,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
`;
